import { eventsTable } from '@/controllers/events-table'
import { pineapple } from '@/controllers/events'

const [route, action] = ['pineapple', 'get-general-info']

export const getPineappleGeneralInfo = function (callback) {
  window[Symbol.for('vue.prototype')].$sendMessageToWorker({ route, action })

  eventsTable[pineapple[action]] = callback
}
